module.exports = __webpack_public_path__ + "static/img/pryke-saxon.da29ad7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pryke-saxon.jpg
// module id = q3IX
// module chunks = 0